import detectMobile from "./detect-mobile.js";

const products = document.querySelectorAll("[data-toggle-grid]");
const $activeGrid = document.querySelector("[data-active-grid]");
const $activeGridM = document.querySelector("[data-active-grid-mobile]");
const $loadMoreButton = document.querySelector("[data-load-more-products=\"btn\"]");
const arrBtnToggleFilter = document.querySelectorAll("[data-toggle-filter]");
const $loadMoreProducts = document.querySelectorAll("[data-load-more-products=\"product\"]");
const userTypeGrid = localStorage.getItem("productsGridType");
const onlyGrid = document.querySelector("[data-only-grid]")?.getAttribute("data-only-grid"); // приоритетная раскладка
const mobileTypeGrid = detectMobile() && $activeGridM && $activeGridM.dataset.activeGridMobile;
const typeGrid = mobileTypeGrid || onlyGrid || userTypeGrid || "grid";

/** Применяем раскладку, которая была ранее выбрана пользователем */
$activeGrid?.setAttribute("data-active-grid", typeGrid);

/** Обработка переключений раскладок */
products.forEach((i) => {
	i.addEventListener("click", function () {
		const typeToggleGrid = this.getAttribute("data-toggle-grid");

		localStorage.setItem("productsGridType", typeToggleGrid); // записываем текущий вид раскладки продукции
		document.querySelector("[data-active-grid]").setAttribute("data-active-grid", typeToggleGrid);
	});
});

/** Показ "остального" фильтра */
if ($loadMoreButton && $loadMoreProducts.length > 0) {
	$loadMoreButton.addEventListener("click", (e) => {
		e.preventDefault();

		$loadMoreProducts.forEach((i) => i.classList.remove("d-none"));
		$loadMoreButton.parentElement.classList.add("d-none");
	});
}

arrBtnToggleFilter.forEach((btn) => btn.addEventListener("click", function () {
	const { toggleFilter } = this.dataset;
	const $filter = document.querySelector(toggleFilter);
	const isOpen = $filter.classList.contains("d-none");

	$filter.classList.toggle("d-none", !isOpen);
	document.body.classList.toggle("overflow-hidden", isOpen);
}));
